import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=554a6332&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a6332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554a6332')) {
      api.createRecord('554a6332', component.options)
    } else {
      api.reload('554a6332', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=554a6332&scoped=true&", function () {
      api.rerender('554a6332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SvDqDl83re7W/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports